import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  paper: {
    height: '100%',
  },
  root: {
    width: '100%',
    height: theme.settings.size.mobile.mainPaperHeight,
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: 100,
    backgroundColor: theme.palette.colors.white,
    [theme.breakpoints.up('mobile')]: {
      height: '100vh',
    },
  },
}));



// WEBPACK FOOTER //
// ./src/components/BuyerMessages/components/MobileMessages/useStyles.js